"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.title = exports.price = exports.listingInfo = exports.listingCard = exports.infoSection = exports.image = exports.featureText = exports.featureGroup = exports.feature = exports.agentPhoto = exports.agentInfo = exports.agencyLogo = exports.addressLine2 = exports.addressLine1 = exports.addressContainer = void 0;
var _core = require("@emotion/core");
var _feBrary = require("@domain-group/fe-brary");
var _feCoAllhomesDesignSystem = require("@domain-group/fe-co-allhomes-design-system");
var _common = require("../common.style");
var colour = _feBrary.variables.colour,
  font = _feBrary.variables.font,
  global = _feBrary.variables.global;
var Size = {
  large: {
    width: 486,
    height: 384
  },
  small: {
    width: 324,
    height: 258
  }
};
var getSize = size => Size[size] || Size.large;
var listingCard = _ref2 => {
  var size = _ref2.size;
  return /*#__PURE__*/(0, _core.css)("width:", getSize(size).width, "px;height:", getSize(size).height, "px;flex-shrink:0;position:relative;:before{position:absolute;top:0;left:0;height:18%;width:100%;background-image:linear-gradient( to bottom,rgba(0,0,0,0.4),rgba(0,0,0,0) );content:'';z-index:", global.layerOverlay, ";}:after{position:absolute;bottom:0;left:0;height:50%;width:100%;background-image:linear-gradient( to bottom,rgba(0,0,0,0),rgba(0,0,0,0.6) );content:'';z-index:", global.layerOverlay, ";}");
};
exports.listingCard = listingCard;
var image = exports.image = {
  name: "122y91a",
  styles: "position:absolute;top:0;left:0;width:100%;height:100%;"
};
var infoSection = exports.infoSection = /*#__PURE__*/(0, _core.css)("position:absolute;top:0;left:0;width:100%;height:100%;display:flex;flex-direction:row;align-items:flex-end;justify-content:space-between;z-index:", global.layerOverlay + 1, ";padding:15px;");
var title = exports.title = /*#__PURE__*/(0, _core.css)("position:absolute;top:15px;left:15px;color:", colour.white, ";font-family:", font.headingFontFamily, ";font-weight:", font.headingFontWeight, ";font-size:", font.smallFontSize, ";border-bottom:2px solid ", colour.white, ";width:fit-content;z-index:", global.layerOverlay + 1, ";");
var _ref = {
  name: "1kuy7z7",
  styles: "font-size:14px;"
};
var listingInfo = _ref3 => {
  var size = _ref3.size;
  return /*#__PURE__*/(0, _core.css)("display:flex;flex-direction:column;color:", colour.white, ";", _feCoAllhomesDesignSystem.typography.bodyNoLinks, " ", size === 'small' && _ref, ";line-height:", size === 'large' ? '28' : '20', "px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;");
};
exports.listingInfo = listingInfo;
var price = _ref4 => {
  var size = _ref4.size;
  return /*#__PURE__*/(0, _core.css)(_feCoAllhomesDesignSystem.typography.headingS, " line-height:", size === 'large' ? '28' : '22', "px;");
};
exports.price = price;
var addressContainer = exports.addressContainer = /*#__PURE__*/(0, _core.css)(_feBrary.aNormalize, " display:flex;flex-direction:column;", _common.expandClickZone);
var addressWrap = {
  name: "1d0tddh",
  styles: "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"
};
var addressLine1 = exports.addressLine1 = /*#__PURE__*/(0, _core.css)(addressWrap);
var addressLine2 = _ref5 => {
  var size = _ref5.size;
  return /*#__PURE__*/(0, _core.css)(addressWrap, " max-width:", getSize(size).width - 175, "px;");
};
exports.addressLine2 = addressLine2;
var agentInfo = exports.agentInfo = {
  name: "70vq4s",
  styles: "position:absolute;right:15px;display:flex;flex-direction:row;align-items:center;gap:5px;"
};
var agentPhoto = exports.agentPhoto = {
  name: "kn46u7",
  styles: "width:48px;height:48px;"
};
var agencyLogo = exports.agencyLogo = {
  name: "13btmrt",
  styles: "max-width:125px;height:25px;object-fit:contain;"
};
var featureGroup = exports.featureGroup = {
  name: "knzbj2",
  styles: "display:flex;flex-direction:row;gap:10px;"
};
var feature = exports.feature = {
  name: "1szb2xj",
  styles: "display:flex;gap:5px;align-items:center;"
};
var featureText = _ref6 => {
  var size = _ref6.size;
  return /*#__PURE__*/(0, _core.css)(size === 'large' ? _feCoAllhomesDesignSystem.typography.bodyBold : _feCoAllhomesDesignSystem.typography.bodySmallBold, " line-height:28px;");
};
exports.featureText = featureText;